export const ACCESS_TIERS = {
  A_PLUS: "a_plus",
  A_PLUS_TEACHER: "a_plus_teacher",
  FREE: "free",
  SIGNED_OUT: "signed_out"
};
